import React, { useState } from 'react';
import "./Sidebar.css";

/*const folderMappings = {
  Inbox: "INBOX",
  Sent: "[Gmail]/Sent Mail",
  Drafts: "[Gmail]/Drafts",
  Trash: "[Gmail]/Trash",
  Spam: "[Gmail]/Spam",
  Starred: "[Gmail]/Starred",
  Important: "[Gmail]/Important",
  "All Mail": "[Gmail]/All Mail", // needs to be in quotes for it to be two words
};*/



const folderMappings = {
  Inbox: "INBOX",
  
};

/*≡*/
function Sidebar({ onComposeClick, onRefreshClick,onLoginClick, onSelectFolder, selectedFolder }) {
	const [menuOpen, setMenuOpen] = useState(false);
	
	const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

	return (
	<div>
		<button
			type="button"
			className="menu-toggle"
			onClick={toggleMenu}
		>
			<span className="menu-icon"></span>
			{menuOpen ? "⬅️" : "➡️"}
		</button>
		
		<div className={menuOpen ? "sidebar" : "sidebar closed"}>
		  <h2>Oglasi.rs<span id="logo-span">Mail</span></h2>
		  <div className="sidebar-menu">
			{Object.keys(folderMappings).map((folder) => (
			  <div
				key={folder}
				className={`sidebar-item ${selectedFolder === folderMappings[folder] ? "sidebar-item-active" : ""}`}
				onClick={() => onSelectFolder(folderMappings[folder])} // Set correct folder format (gmail)
			  >
				{folder}
			  </div>
			))}
		  </div>
		  <button className="compose-btn" onClick={onComposeClick}>Compose</button>
		  <button className="refresh-btn" onClick={onRefreshClick}>Refresh</button>
		  <button className="login-btn" onClick={()=>{onLoginClick();toggleMenu();} }>Log in</button>
		</div>
	</div>
  );
}

export default Sidebar;